var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIllLError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80 80"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--danger-40, #E34646)",
  d: "M28.5 30c0-11.598 9.402-21 21-21s21 9.402 21 21-9.402 21-21 21-21-9.402-21-21"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#ill-l-error_svg__a)",
  d: "M8.5 43c0-15.464 12.536-28 28-28s28 12.536 28 28-12.536 28-28 28-28-12.536-28-28"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.7,
  d: "M40.99 33.57a1.91 1.91 0 0 1 2.72 0l2.036 2.055c.751.758.751 1.987 0 2.746l-3.699 3.733a1.14 1.14 0 0 0 0 1.599l3.89 3.926c.75.759.75 1.988 0 2.746L43.9 52.432a1.91 1.91 0 0 1-2.72 0l-3.887-3.925a1.116 1.116 0 0 0-1.588 0l-3.886 3.925a1.91 1.91 0 0 1-2.72 0l-2.036-2.057a1.955 1.955 0 0 1 0-2.746l3.888-3.926a1.14 1.14 0 0 0 0-1.6l-3.698-3.732a1.955 1.955 0 0 1 0-2.746l2.036-2.057a1.91 1.91 0 0 1 2.72 0l3.696 3.732c.438.443 1.15.443 1.588 0z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ill-l-error_svg__a",
  x1: 8.5,
  x2: 64.5,
  y1: 71,
  y2: 15,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--danger-10, #FCC8B6)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--danger-40, #E34646)"
})))));
export default SvgIllLError;